export default __webpack_public_path__ + "static/hp-desktop-2562e295b4d14102f69d6edfad859df3.png";